module.exports = __webpack_public_path__ + "assets/img/SOS.d6280a1e.png";